export const DESIGN_WIDTH = 2580
export const DESIGN_HEIGHT = 1920
export const ASSET_BASE = '/assets/three-kings-scratch'
export const HOW_TO_PLAY_STORAGE_KEY = 'three-kings-scratch-how-to-play'
export const SOUND_PROMPT_KEY = 'three-kings-scratch-sound-prompt'

export const GAME_PHASE = {
  IDLE: 'idle',
  SCRATCHING: 'scratching',
  RESULT: 'result'
}

export const VARIANTS = {
  GREEN: 'GREEN',
  PURPLE: 'PURPLE',
  RED: 'RED'
}

export const VARIANT_META = {
  GREEN: {
    key: 'GREEN',
    color: 0x006037,
    accent: '#00e676',
    rows: 3,
    columns: 4,
    fieldSize: 12,
    fixedBet: 5,
    priceText: '5 FUN',
    crownType: 'bronze',
    maxMultiplier: 25000,
    defaultBetRatio: 1
  },
  PURPLE: {
    key: 'PURPLE',
    color: 0x5c0d66,
    accent: '#d8b4fe',
    rows: 4,
    columns: 4,
    fieldSize: 16,
    fixedBet: 10,
    priceText: '10 FUN',
    crownType: 'silver',
    maxMultiplier: 15000,
    defaultBetRatio: 2
  },
  RED: {
    key: 'RED',
    color: 0x850a24,
    accent: '#fda4af',
    rows: 4,
    columns: 5,
    fieldSize: 20,
    fixedBet: 20,
    priceText: '20 FUN',
    crownType: 'gold',
    maxMultiplier: 10000,
    defaultBetRatio: 4
  }
}

export const PAYTABLE = {
  GREEN: [0, 0.5, 1, 2, 5, 10, 25, 50, 100, 500, 2000, 5000, 25000],
  PURPLE: [0, 0.5, 1, 2, 4, 10, 20, 40, 100, 300, 1000, 3000, 15000],
  RED: [0, 0.5, 1, 2, 4, 8, 15, 30, 80, 200, 500, 2000, 10000]
}

export const WEBP_SYMBOLS = [3, 11, 17, 30, 31]
export const AUTOPLAY_COUNTS = [25, 50, 100, 250, 500, 750, 1000, '∞']
export const LIMIT_PRESETS = [5, 20, 50, 'No Limit']
export const DEFAULT_VARIANT = VARIANTS.GREEN

export const symbolSrc = (id) => {
  const ext = WEBP_SYMBOLS.includes(Number(id)) ? 'webp' : 'png'
  return `${ASSET_BASE}/img/shared/symbols/${id}.${ext}`
}

export const variantFolder = (variant) => String(variant || 'GREEN').toLowerCase()
